// utils/socket.js — Tạo kết nối Socket.IO có kèm JWT token để xác thực
import { io } from 'socket.io-client';

export function createSocket(token, deviceId) {
  return io(process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000', {
    path: '/socket.io',
    auth: { token, deviceId },
    transports: ['websocket'],
    forceNew: true,
    multiplex: false,
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1500,
    reconnectionDelayMax: 8000,
  });
}